import Link from 'next/link';
import { useLoginLink } from '@hooks/useLoginLink';
import Icon from '@components/atoms/icon';

const isUpgradeVariant = (text) => text === 'Upgrade';

type JoinTheHubButtonProps = {
  path: string;
  text: string;
  onClick: () => void;
};

export const JoinTheHubButton = ({
  path,
  text,
  onClick
}: JoinTheHubButtonProps) => {
  const isUpgrade = isUpgradeVariant(text);

  return (
    <>
      <Link
        href={`/${
          isUpgrade
            ? 'member-upgrade'
            : text === 'AI Team Rating'
            ? 'ai-team-rating'
            : 'join'
        }`}
        id="join-the-hub-header-button"
        onClick={onClick}
        className={`hover:${
          isUpgrade ? 'bg-primary-800' : 'bg-danger-700'
        } transition-colors ${
          isUpgrade ? 'bg-primary' : 'bg-danger-500'
        } text-white font-bold font-open-sans px-4 py-2 rounded-lg ${
          path === '/join' || path.includes('subscribe/') ? 'active' : ''
        }`}
      >
        {text}
      </Link>
    </>
  );
};

export const DesktopLoginButton = ({ children, returnTo }) => {
  const loginLink = useLoginLink(returnTo);

  return (
    <Link
      prefetch={false}
      {...loginLink}
      className="px-4 text-base font-bold text-white text-open-sans"
      data-cy="account-menu-login"
    >
      {children}
    </Link>
  );
};

export const MobileLoginButton = ({
  returnTo,
  children,
  onClick
}: {
  returnTo?: string;
  children: string;
  onClick: () => void;
}) => {
  const loginLink = useLoginLink(returnTo);

  return (
    <Link
      prefetch={false}
      {...loginLink}
      onClick={(event) => {
        onClick();
        loginLink.onClick(event);
      }}
      className="rounded-lg text-white py-2 px-3 font-bold font-open-sans bg-transparent border-2 border-white"
      data-cy="mobile-menu-login"
    >
      {children}
    </Link>
  );
};

export const SignOutButton = ({ onClick, ...rest }) => (
  <a
    onClick={onClick}
    className="hidden lg:block px-4 py-2 text-xs font-semibold cursor-pointer text-neutral-50"
    data-cy="logout"
    {...rest}
  >
    <Icon name="SignOut"></Icon>
  </a>
);

export const MobileMenuButton = ({ showMobileMenu, toggle }) => (
  <button
    onClick={() => toggle()}
    className="text-white ml-2"
    aria-expanded="false"
    data-cy="mobile-menu-button"
  >
    <span className="sr-only">{'Open main menu'}</span>
    {!showMobileMenu && (
      <Icon name="Hamburger" className="text-white cursor-pointer"></Icon>
    )}
  </button>
);
